export default {
  name: 'DeviceTemplateDataRouting',
  props: {
    template: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};